const NotApplyToSectionPart1Pluss = () => {
  return (
    <>
      <h2>Forsikringen gjelder ikke for:</h2>
      <ul>
        <li>
          Behandling av sykdom eller plager som har oppstått eller har blitt
          påvist før forsikringen begynte å gjelde, omfattes ikke av
          forsikringen.
        </li>
        <li>
          Medisinsk utredning eller behandling som ikke har blitt godkjent på
          forhånd av forsikringsselskapet
        </li>
        <li>
          Akutt sykdom/plager, akutt medisinsk behandling, akutt transport og
          utgifter i forbindelse med akutt medisinsk behandling
        </li>
        <li>
          Konsultasjon hos allmennlege og spesialist i allmennmedisin. Digital
          legetjeneste eller videokonsultasjon hos en leverandør Avonova har
          avtale med er likevel omfattet.
        </li>
        <li>
          Forsikringen omfatter ikke forebyggende behandling,
          vedlikeholdsbehandlinger, vaksinasjoner, helsesjekk og undersøkelser
          som har helseforebyggende hensikt, herunder undersøkelser i den
          hensikt å avklare risiko for sykdom og screeningundersøkelser.
        </li>
      </ul>
    </>
  );
};

export default NotApplyToSectionPart1Pluss;
